import { FC } from "react";
import { useTranslation } from "react-i18next";

import { DirectionEnum, errors } from "@ryde/shared";

import { BoardingSegmentDurationTooltipContentStyled } from "./boarding-segment-duration-tooltip-content.styled";

interface IBoardingSegmentDurationTooltipContentProps {
  direction?: DirectionEnum;
  boardingSegmentMinutes: string | number;
  totalMinutes: string | number;
  maxMinutes?: string | number;
  isExceeded?: boolean;
}

export const BoardingSegmentDurationTooltipContent: FC<
  IBoardingSegmentDurationTooltipContentProps
> = ({
  direction,
  boardingSegmentMinutes,
  totalMinutes,
  maxMinutes,
  isExceeded = false,
}) => {
  const { t } = useTranslation();
  const isDropOff = direction === DirectionEnum.DropOff;
  const hasMax = maxMinutes !== undefined && maxMinutes !== "";

  const titleKey = isDropOff
    ? "ride.formLabel.boardingSegmentDurationTooltipDropOffTitle"
    : "ride.formLabel.boardingSegmentDurationTooltipPickupTitle";
  const descriptionKey = isDropOff
    ? "ride.formLabel.boardingSegmentDurationTooltipDropOffDescription"
    : "ride.formLabel.boardingSegmentDurationTooltipPickupDescription";
  const maxKey = isDropOff
    ? "ride.formLabel.boardingSegmentDurationTooltipDropOffMax"
    : "ride.formLabel.boardingSegmentDurationTooltipPickupMax";

  return (
    <BoardingSegmentDurationTooltipContentStyled>
      <p className="boarding-segment-duration-tooltip__title">
        {t(titleKey, { boardingSegmentMinutes })}
      </p>
      <p>{t(descriptionKey)}</p>
      <p>
        {t("ride.formLabel.boardingSegmentDurationTooltipTotal", {
          totalMinutes,
        })}
      </p>
      {hasMax && <p>{t(maxKey, { maxMinutes })}</p>}
      {isExceeded && hasMax && (
        <p>
          {t(errors.ride.boardingSegmentDurationExceeded, {
            rideValue: boardingSegmentMinutes,
            priceRateValue: maxMinutes,
          })}
        </p>
      )}
    </BoardingSegmentDurationTooltipContentStyled>
  );
};
